import Utils from "../utils/Utils";

const getAuth = ({ jwt, Authorization } = {}) => jwt || Authorization || "";

const addParam = (params, key, value) => {
  if (value !== undefined && value !== null && value !== "") {
    params.append(key, value);
  }
};

const whishPayController = {
  getAccountBalance: ({ Authorization, currency, jwt } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "currency", currency);

    return Utils.controller(
      "api/whish/v1/account/balance",
      "",
      "GET",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
      "application/json",
    );
  },

  acknowledgeFailureCallback: ({ paymentId, token } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "paymentId", paymentId);
    addParam(params, "token", token);

    return Utils.controller(
      "api/whish/v1/callbacks/failure",
      "",
      "GET",
      params.toString(),
      false,
      "",
      true,
      "application/json",
    );
  },

  acknowledgeSuccessCallback: ({ paymentId, token } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "paymentId", paymentId);
    addParam(params, "token", token);

    return Utils.controller(
      "api/whish/v1/callbacks/success",
      "",
      "GET",
      params.toString(),
      false,
      "",
      true,
      "application/json",
    );
  },

  checkout: ({ Authorization, jwt, request } = {}) => {
    return Utils.controller(
      "api/whish/v1/checkout",
      request,
      "POST",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
      "application/json",
    );
  },

  getPayment: ({ Authorization, jwt, paymentId } = {}) => {
    return Utils.controller(
      `api/whish/v1/payments/${paymentId}`,
      "",
      "GET",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
      "application/json",
    );
  },

  refundPayment: ({ Authorization, jwt, paymentId, request } = {}) => {
    return Utils.controller(
      `api/whish/v1/payments/${paymentId}/refund`,
      request,
      "POST",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
      "application/json",
    );
  },

  startPayment: ({ Authorization, jwt, paymentId } = {}) => {
    return Utils.controller(
      `api/whish/v1/payments/${paymentId}/start`,
      "",
      "POST",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
      "application/json",
    );
  },

  syncPayment: ({ Authorization, jwt, paymentId } = {}) => {
    return Utils.controller(
      `api/whish/v1/payments/${paymentId}/sync`,
      "",
      "POST",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
      "application/json",
    );
  },

  purchaseCredits: ({ Authorization, jwt, request } = {}) => {
    return Utils.controller(
      "api/whish/v1/wallet/credits",
      request,
      "POST",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
      "application/json",
    );
  },

  getWalletPlans: ({ Authorization, jwt } = {}) => {
    return Utils.controller(
      "api/whish/v1/wallet/plans",
      "",
      "GET",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
      "application/json",
    );
  },

  createWalletTopUp: ({ Authorization, jwt, request } = {}) => {
    return Utils.controller(
      "api/whish/v1/wallet/top-ups",
      request,
      "POST",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
      "application/json",
    );
  },
};

export default whishPayController;
